export default {
  common: {

  },
  app: {
    
  }
}


// WEBPACK FOOTER //
// ./src/locales/lang-en.js